import React, { useContext, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { NavLink } from 'react-router-dom';
import { Page } from 'Components';
import { Pathname } from 'Routes';
import cn from 'classnames';
import styles from './index.module.css';

export const SettingsPage = ({ children, title, description }) => {
    // eslint-disable-next-line no-script-url
    window.location.href = 'javascript: $zopim.livechat.button.hide()';
  const { langText, getAccessChecker, lineReq, setTopOrBottom, apiResponse, userAccessedData, managerPrivatePlanAccess } = useContext(AppContext);
  const { isInActiveUser } = useContext(AuthContext);
  const sideBarText = langText?.settings;

  // Same condition as header UploadDropdown for showing cloud options
  const showCloudOptions = apiResponse?.data?.[0]?.private_plan_access === '1'
    || apiResponse?.data?.[0]?.private_plan_access === 1
    || (userAccessedData && managerPrivatePlanAccess);

  useEffect(() => {
    setTopOrBottom(true);
    return () => {
      setTopOrBottom(false); // Set topOrBottom to false when leaving the component
    };
  }, []);

  const baseLinks = [
    { name: (sideBarText?.accountSideBarTitle || 'Account'), link: Pathname.getSettingsPath(Pathname.settings.accounts) },
    { name: (sideBarText?.notificationSidebarTitle || 'Notifications'), link: Pathname.getSettingsPath(Pathname.settings.notifications) },
    { name: ('Billing & Payments' || sideBarText?.billPaymentSidebarTitle), link: Pathname.getSettingsPath(Pathname.settings.billings) },
    { name: (sideBarText?.privacySidebarTitle || 'Privacy'), link: Pathname.getSettingsPath(Pathname.settings.privacy) },
    { name: 'User Management', link: Pathname.getSettingsPath(Pathname.settings.manageUsers) },
    { name: 'Referrals', link: Pathname.getSettingsPath(Pathname.settings.referrals) },
    { name: (sideBarText?.termsSidebarTitle || 'Terms of Use'), link: Pathname.getSettingsPath(Pathname.settings.termsAndConditions) },
    { name: (sideBarText?.subscriberSidebarTitle || 'Subscriber Agreement'), link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement) }
  ];

  // Add Cloud option only for users with private_plan_access
  const commonSidebarLinks = showCloudOptions
    ? [
      { name: (sideBarText?.accountSideBarTitle || 'Account'), link: Pathname.getSettingsPath(Pathname.settings.accounts) },
      { name: (sideBarText?.cloudSidebarTitle || 'Cloud'), link: Pathname.getSettingsPath(Pathname.settings.cloud) },
      { name: (sideBarText?.notificationSidebarTitle || 'Notifications'), link: Pathname.getSettingsPath(Pathname.settings.notifications) },
      { name: ('Billing & Payments' || sideBarText?.billPaymentSidebarTitle), link: Pathname.getSettingsPath(Pathname.settings.billings) },
      { name: (sideBarText?.privacySidebarTitle || 'Privacy'), link: Pathname.getSettingsPath(Pathname.settings.privacy) },
      { name: 'User Management', link: Pathname.getSettingsPath(Pathname.settings.manageUsers) },
      { name: 'Referrals', link: Pathname.getSettingsPath(Pathname.settings.referrals) },
      { name: (sideBarText?.termsSidebarTitle || 'Terms of Use'), link: Pathname.getSettingsPath(Pathname.settings.termsAndConditions) },
      { name: (sideBarText?.subscriberSidebarTitle || 'Subscriber Agreement'), link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement) }
    ]
    : baseLinks;

  // Match the sidebar banner's visibility: hide User Management only when
  // BOTH the backend says we're in an access session AND the frontend
  // marker confirms the user came in via the Access button. Without the
  // marker, a stale /getUserAccess response could falsely hide the link.
  const isImpersonating = getAccessChecker?.success === true
    && localStorage.getItem('isAccessingUser') === 'true';

  const sidebarLinks = isInActiveUser ? [
    { name: ('Billings and Payments' || sideBarText?.billPaymentSidebarTitle), link: Pathname.getSettingsPath(Pathname.settings.billings) },
    { name: (sideBarText?.privacySidebarTitle || 'Privacy'), link: Pathname.getSettingsPath(Pathname.settings.privacy) },
    { name: (sideBarText?.termsSidebarTitle || 'Terms of Use'), link: Pathname.getSettingsPath(Pathname.settings.termsAndConditions) },
    { name: (sideBarText?.subscriberSidebarTitle || 'Subscriber Agreement'), link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement) }
  ] : isImpersonating
  ? (showCloudOptions
    ? [
      { name: (sideBarText?.accountSideBarTitle || 'Account'), link: Pathname.getSettingsPath(Pathname.settings.accounts) },
      { name: (sideBarText?.cloudSidebarTitle || 'Cloud'), link: Pathname.getSettingsPath(Pathname.settings.cloud) },
      { name: (sideBarText?.notificationSidebarTitle || 'Notifications'), link: Pathname.getSettingsPath(Pathname.settings.notifications) },
      { name: ('Billing & Payments' || sideBarText?.billPaymentSidebarTitle), link: Pathname.getSettingsPath(Pathname.settings.billings) },
      { name: (sideBarText?.privacySidebarTitle || 'Privacy'), link: Pathname.getSettingsPath(Pathname.settings.privacy) },
      { name: (sideBarText?.termsSidebarTitle || 'Terms of Use'), link: Pathname.getSettingsPath(Pathname.settings.termsAndConditions) },
      { name: (sideBarText?.subscriberSidebarTitle || 'Subscriber Agreement'), link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement) }
    ]
    : [
      { name: (sideBarText?.accountSideBarTitle || 'Account'), link: Pathname.getSettingsPath(Pathname.settings.accounts) },
      { name: (sideBarText?.notificationSidebarTitle || 'Notifications'), link: Pathname.getSettingsPath(Pathname.settings.notifications) },
      { name: ('Billing & Payments' || sideBarText?.billPaymentSidebarTitle), link: Pathname.getSettingsPath(Pathname.settings.billings) },
      { name: (sideBarText?.privacySidebarTitle || 'Privacy'), link: Pathname.getSettingsPath(Pathname.settings.privacy) },
      { name: (sideBarText?.termsSidebarTitle || 'Terms of Use'), link: Pathname.getSettingsPath(Pathname.settings.termsAndConditions) },
      { name: (sideBarText?.subscriberSidebarTitle || 'Subscriber Agreement'), link: Pathname.getSettingsPath(Pathname.settings.subscriberAgreement) }
    ])
  : commonSidebarLinks;
  return (
    <Page noBottomBar contentClassName={styles.pageContent} headerTheme={styles.headerTheme}>
      <div className={styles.settingsPage}>
        <div className={styles.sidebar}>
          <div className={styles.sidebarContent}>
          {sidebarLinks.map(({ name, link }, idx) => {
          const isActive = window.location.pathname === link;
          const navLinkClassName = cn(styles.sidebarLink, { [styles.currentSidebarLink]: isActive });
          return (
            <NavLink
              key={idx}
              to={link}
              className={navLinkClassName}
            >
             {name}
            </NavLink>
          );
        })}
          </div>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.pageTitle}>{title}</div>
          <div className={styles.pageDescription}>{description}</div>
          {lineReq === false && <hr className={styles.pageDivider} />}
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </Page>
  );
};
